// noinspection JSNonASCIINames

import { type TechnicalDetailsData, type TechnicalDetailsDataEntry } from "../ProductDetails/dto/PdpPageProductDataDto";
import { type FeatureData } from "../utils/models";
import { UnitMode } from "./redux/UnitMode";
import { SEARCH_TECH_VALUE_TABLE_THRESHOLD } from "../utils/constants";

export const IMPERIAL_UNITS = {
  inch: true,
  in: true,
  lbf: true,
  "°F": true,
  psi: true,
  oz: true,
  "oz/inch": true,
  "oz/in": true,
  lbs: true,
  "lbs/inch": true,
  "lbs/in": true,
  lbsf: true,
  gal: true,
  yard: true,
  "ft-lbs": true,
  "in²": true,
  "lbs/in³": true,
  floz: true,
};

export const METRIC_UNITS = {
  mm: true,
  N: true,
  kg: true,
  "°C": true,
  bar: true,
  g: true,
  "g/m": true,
  "kg/m": true,
  kN: true,
  l: true,
  "l/min": true,
  m: true,
  "m/s": true,
  mg: true,
  "mm/min": true,
  MPa: true,
  "N/min": true,
  "Nm/mrad": true,
  Nm: true,
  "cm²": true,
  "kg/dm³": true,
  "mm²/s": true,
  "cm³": true,
  µm: true,
};

export function filterTechnicalDetails(table: TechnicalDetailsData, mode: UnitMode): TechnicalDetailsData {
  return {
    ...table,
    entries: table.entries.filter(makeTechnicalDetailsDataEntryFilter(mode)),
  };
}

const makeTechnicalDetailsDataEntryFilter = (mode: UnitMode) => {
  const invalidUnits = mode === UnitMode.Imperial ? METRIC_UNITS : IMPERIAL_UNITS;
  return (entry: TechnicalDetailsDataEntry) => {
    return !invalidUnits[entry.unitSymbol];
  };
};

export function filterFeatures(features: FeatureData[], mode: UnitMode): FeatureData[] {
  return features.filter(makeFeaturesFilter(mode)).slice(0, SEARCH_TECH_VALUE_TABLE_THRESHOLD);
}

const makeFeaturesFilter = (mode: UnitMode) => {
  const invalidUnits = mode === UnitMode.Imperial ? METRIC_UNITS : IMPERIAL_UNITS;
  return (entry: FeatureData) => {
    return !invalidUnits[entry.unit];
  };
};
